import { gql } from '@apollo/client';

export const MARK_ALL_NOTIFICATION_READ_MUTATION = gql`
  mutation MarkAllAsRead {
    markAllRead {
      affected
    }
  }
`;